import { ConfigurationHeaderWrapper } from '../../_components/configuration-header-wrapper.component'

export default function ConfigurationFollowupsAddPage() {
  return <ConfigurationHeaderWrapper title={'todo'}>TODO</ConfigurationHeaderWrapper>
}
